import { FormEvent, useState } from "react";
import styled from "styled-components";
import { BsSend } from "react-icons/bs";

type Props = {
  onSend: (message: string) => void;
  disabled?: boolean;
};

const ChatInput = ({ onSend, disabled }: Props) => {
  const [value, setValue] = useState("");

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    const trimmed = value.trim();
    if (!trimmed || disabled) return;
    onSend(trimmed);
    setValue("");
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Input
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder="Ask about projects, experience, skills..."
        disabled={disabled}
        maxLength={500}
        aria-label="Chat message"
      />
      <SendButton type="submit" disabled={disabled || !value.trim()} aria-label="Send message">
        <BsSend />
      </SendButton>
    </Form>
  );
};

export default ChatInput;

const Form = styled.form`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;

const Input = styled.input`
  flex: 1;
  padding: 0.65rem 0.85rem;
  border-radius: 10px;
  border: 1px solid var(--border-muted);
  background: var(--surface-card);
  color: var(--white-dart);
  font-size: 0.88rem;
  outline: none;
  transition: var(--transition);

  &::placeholder {
    color: var(--text-secondary);
    opacity: 0.8;
  }

  &:focus {
    border-color: var(--border-accent);
    box-shadow: 0 0 0 2px var(--accent-bg);
  }

  &:disabled {
    opacity: 0.6;
  }
`;

const SendButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 10px;
  border: 1px solid var(--border-accent);
  background: var(--accent-bg);
  color: var(--green);
  cursor: pointer;
  transition: var(--transition);

  &:hover:not(:disabled) {
    background: var(--accent-bg-hover);
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
`;
